export const environment = {
  production: true,
  api: 'https://ai.advancti.com/api/v1',
};
